module.exports = __webpack_public_path__ + "static/img/Group 354.5554b4e9.png";